import { useQuery } from '@tanstack/react-query';
import { api, ApiError } from '../api';
import type { Me } from './me';

export const ME_KEY = ['me'] as const;

/** Current session. `me` is undefined when nobody is logged in. */
export function useMe() {
  const query = useQuery({
    queryKey: ME_KEY,
    queryFn: async (): Promise<Me | null> => {
      try {
        return await api<Me>('/api/auth/me', { allowUnauthorized: true });
      } catch (error) {
        if (error instanceof ApiError && error.status === 401) return null;
        throw error;
      }
    },
  });
  return { me: query.data ?? undefined, isLoading: query.isLoading, error: query.error };
}
